<template>
    <div class="msg-input-wrap">
        <form class="msg-form" @submit="submit">
            <textarea
                v-model="msg"
                rows="1"
                placeholder="Enter Messages..."
                class="msg-input"
            >
            </textarea>
        </form>
        <div :class="['send-button', msg.length ? 'active' : '']" @click="submit"></div>
    </div>

</template>

<script>
import Input from '@/components/Input';

export default {
  components: {
    Input,
  },
  data() {
    return {
      msg: '',
    };
  },
  methods: {
    submit(e) {
      e.preventDefault();
      if (!this.msg) return;
      this.$emit('send', this.msg);
      this.msg = '';
    },
  },
};
</script>

<style lang="less">
.msg-input-wrap {
    position: absolute;
    width: 328px;
    height: 56px;
    padding: 0 20px;
    bottom: 42px;
    left: 16px;
    border-radius: 28px;
    background-color: #fff;
    display: flex;
    align-items: center;
    .msg-form {
        flex: 1;
        height: 24px;
        .msg-input {
            width: 100%;
            height: 100%;
            color: @black;
            font-size: 18px;
            font-weight: 600;
            line-height: 24px;
            border: none;
            outline: none;
            &::placeholder {
                color: @gray;
                font-size: 14px;
                line-height: 24px;
            }
        }
    }
    .send-button {
        margin-left: 10px;
        .iconMixin({
            background-image: url('~@/assets/images/chat/send.png');
        });
        &.active {
            background-image: url('~@/assets/images/chat/send-active.png');
        }
    }

}

</style>
